/**
 * Gerenciamento de consentimento LGPD (Lei 13.709/2018).
 * O GTM/Analytics só é carregado após o usuário aceitar.
 */
const CONSENT_KEY = "equilybra_cookie_consent";
const GTM_ID = "GTM-54CFN3TV";

export type ConsentState = "accepted" | "rejected" | null;

export function getConsent(): ConsentState {
  try {
    const v = localStorage.getItem(CONSENT_KEY);
    return v === "accepted" || v === "rejected" ? v : null;
  } catch {
    return null;
  }
}

export function setConsent(state: "accepted" | "rejected") {
  try {
    localStorage.setItem(CONSENT_KEY, state);
  } catch {
    /* ignore */
  }
  if (state === "accepted") loadGTM();
}

let gtmLoaded = false;
export function loadGTM() {
  if (gtmLoaded || typeof window === "undefined") return;
  gtmLoaded = true;

  // dataLayer init
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
}

export function initConsent() {
  if (getConsent() === "accepted") loadGTM();
}
